import { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Navigation from '../../../components/navbar';
import BlogsCard from "./../../../components/blog/components/blogs-cards/index";
import Footer from '../../../components/footer';
import { Link, useLocation } from "react-router-dom";
import { useLocationPathName } from "./../../../hooks/useLocationPathname";
import { Colors } from '../../../utils/colors/colors';
import styled from 'styled-components';
import ButtonComponent from '../../../utils/button/ButtonComponent';
import {
  ADMIN_WRITE,
  ADMIN_DRAFT,
} from '../../../routes/index.routes';
import SkeletonComponent from '../../../utils/skeleton-component/SkeletonComponent';
import { useGetBlogsData } from '../../../api/blog.api';
import { toast } from "react-toastify";












export default function AdminBlogComponent() {


  const [blogData, setBlogData] = useState([]);
  const location = useLocation();
  const { result } = useLocationPathName(location);
  const [title, setTitle] = useState("Eraconneckt | Blog");

  const {
    primaryColor,
    secondaryColor
  } = Colors()


  useEffect(() => {

    setTitle(`Eraconneckt | Blog`);
  }, []);


  useEffect(() => {
    // This will run when the page first loads and whenever the title changes
    document.title = title;
  }, [title]);


  const {
    status,
    data,
    error
  } = useGetBlogsData();

  useEffect(() => {
    if (status === "success") {
      setBlogData(data?.data)
    }
  }, [data?.data, status])

  status === "error" && toast.error(error?.response?.data?.error);



  return (
    <>
      <Navigation />

      <Container>
        <Header
          className="heading"
        >
          <p
            style={{
              marginTop: 0,
              marginBottom: 0,
            }}
          >
            {result}
          </p>

          <LinkWrapper>
            <Link
              to={ADMIN_DRAFT}
            >
              <p
                style={{
                  marginTop: 0,
                  marginBottom: 0,
                  color: secondaryColor,
                }}
              >
                Blog drafts
              </p>
            </Link>
            <ButtonComponent
              href={ADMIN_WRITE}
              text={`Write Blog`}
              bgColor={primaryColor}
              style={``}
              click={() => { }}
              variant={``}
              isLoading={``}
              cName={`border-transparent`}
            />

          </LinkWrapper>
        </Header>
      </Container>


      <div
        style={{
          position: "relative",
          top: "25vh"
        }}>

        <>
          {status === "pending" ? (<SkeletonComponent count={14} />) :
            <BlogsCard
              data={blogData}
              pagePath={"blog"}
            />

          }
        </>

      </div>

      <Footer />

    </>
  )
}




const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 7rem;
`;

const LinkWrapper = styled.div`
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
`;